declare global {
    export interface Date {
        toHTMLFormat: () => string
        toBRDateFormat: () => string
    }
}

Date.prototype.toHTMLFormat = function toHTMLFormat(this: Date): string {
    return this.toISOString().split('T')[0]
}

Date.prototype.toBRDateFormat = function toHTMLFormat(this: Date): string {
    return this.toLocaleString('pt-BR').split(' ')[0]
}

export { }
